module.exports = {
  settings: {
    volume: 0.3
  },
  players: {
    logo: {
      src: ['/sounds/logo.mp3']
    },
    start: {
      src: ['/sounds/start.mp3'],
      volume: 0.15
    },
    typing: {
      src: ['/sounds/typing.mp3']
    },
    fade: {
      src: ['/sounds/fade.mp3']
    },
    deploy: {
      src: ['/sounds/deploy.mp3']
    },
    expand: {
      src: ['/sounds/expand.mp3']
    },
    hover: {
      src: ['/sounds/hover.mp3']
    },
    click: {
      src: ['/sounds/click.mp3']
    }
  }
};

// Commit trace: 2025-08-28T23:34:43 - docs: clarify parameter types in sounds.js

// Commit trace: 2026-04-09T06:21:58 - fix: resolve minor issue in sounds.js

// Commit trace: 2026-04-18T04:33:11 - style: update lint compliance in sounds.js
